
import { defineComponent, nextTick, reactive, ref, toRefs, watch, computed, ComputedRef, createVNode } from 'vue'
import { useRoute } from 'vue-router'
import globalsets from '@/utils/globalsets'
import type { PropType } from 'vue'
import type { ValueType, Option, DataType } from './typings'

interface pageDataType {
  time: number | null | string
  count: number | null | string
  from: number
  to: number
  getPopupContainer: { (): Element | null }
}
export default defineComponent({
  components: {},
  props: {
    theme: {
      type: String,
      default: () => {
        return 'light'
      }
    },
    data: {
      type: Object as PropType<DataType>,
      required: true
    },
    unit: String,
    defaultValue: {
      type: Object as PropType<ValueType>
    }
  },
  setup(props: any, context: any) {
    const RefSelect1 = ref()
    const RefSelect2 = ref()
    const route = useRoute()
    const pageData: pageDataType = reactive({
      time: -100,
      count: -1,
      from: 0,
      to: 100,
      getPopupContainer: () => document.querySelector('.ant-collapse')
    })
    watch(
      () => props.defaultValue,
      (val) => {
        pageData.time = val.select1 ? val.select1.value : -100
        if (val.range) {
          pageData.count = -2
          pageData.from = val.range[0]
          pageData.to = val.range[1]
        } else {
          pageData.count = val.select2 ? val.select2.value : -1
          pageData.from = 0
          pageData.to = 100
        }
      },
      {
        deep: true,
        immediate: true
      }
    )
    function changeVal(target?: string) {
      // 如果自定义返回三个值，否则返回两个值
      const res: ValueType = {}
      pageData.time && (res.select1 = props.data.timeOptions.find((item: Option) => item?.value === pageData.time))
      pageData.count && (res.select2 = props.data.countOptions.find((item: Option) => item?.value === pageData.count))
      if (pageData.count !== -2) {
        delete res.range
        if (target === 'count') {
          pageData.from = 0
          pageData.to = 100
        }
      } else {
        res.range = [pageData.from, pageData.to]
        delete res.select2
      }
      if (res.select2 || res.range) {
        context.emit('changeVal', res)
      }
    }
    const filterNumberAndDot = (name: string) => {
      pageData[name] = globalsets.filterNumberAndDot(pageData[name])
      pageData.from = pageData.from > 0 && pageData.from <= 100 ? Number(pageData.from) : 0
      pageData.to = pageData.to >= 0 && pageData.to < 100 ? Number(pageData.to) : 100
      if (pageData.from >= pageData.to) {
        // 最小值大于最大值
        if (name === 'from') {
          pageData.from = 0
        } else {
          pageData.to = 100
        }
      }
    }
    let timer: any
    function changeMinAndMax(key: string) {
      // if (timer) clearTimeout(timer)
      // timer = setTimeout(() => {
        filterNumberAndDot(key)
        changeVal()
      // }, 600)
    }
    function reset() {
      pageData.time = null
      pageData.count = null
      pageData.from = 0
      pageData.to = 100
    }
    function selectBlur() {
      RefSelect1.value.blur()
      RefSelect2.value.blur()
    }
    return {
      ...toRefs(pageData),
      changeMinAndMax,
      changeVal,
      reset,
      RefSelect1,
      RefSelect2,
      selectBlur
    }
  }
})
